import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material';

import { Template } from '../../../../_models/template';
import { Size } from '../../../../_models/size';
import { Update } from '../../../../_models/update';
import { CardService } from '../../card.service';
import { ApplicationNotificationService } from '../../../../shared/application-notification.service';
import { CopyVerticalComponent } from './copy-vertical.component';
import { CopyHorizontalComponent } from './copy-horizontal.component';

@Component({
  moduleId: module.id,
  selector: 'copy-to-component',
  templateUrl: 'copy-to.component.html'
})

export class CopyToComponent implements OnInit {
  public verticalCopyForm: FormGroup;
  public horizontalCopyForm: FormGroup;
  @Input() template: Template;
  @Input() size: Size;

  ngOnInit() {
    // Generate form for vertical copy
    let verticalFormData: any = {};
    for (let size of this.cardService.sizes) {
      if (size !== this.size) {
        verticalFormData[size.name] = [false];
      }
    }

    this.verticalCopyForm = this.formBuilder.group(verticalFormData);

    // Generate form for horizontal copy
    let horizontalFormData: any = {};
    for (const template of this.size.cards) {
      if (template !== this.template) {
        horizontalFormData[template.name] = [false];
      }
    }
    this.horizontalCopyForm = this.formBuilder.group(horizontalFormData);
  }

  constructor(public cardService: CardService, private formBuilder: FormBuilder,
              public appNotificationService: ApplicationNotificationService, public dialog: MatDialog) {}

  copyHorizontal(values:any):void {
    const update_to_copy = new Update(this.template);
    for (const template_name in values) {
      if (values[template_name]) {
        this.cardService.copyUpdateToTemplate(update_to_copy, this.size.name, template_name);
      }
    }
    this.appNotificationService.addGrowl('Successfully copied values to other templates.');
  }

  copyVertical(values:any):void {
    const update_to_copy = new Update(this.template);
    for (const size_name in values) {
      if (values[size_name]) {
        this.cardService.copyUpdateToSize(update_to_copy, size_name);
      }
    }
    this.appNotificationService.addGrowl('Successfully copied values to different sizes.');
  }

  showCopyHorizontalModal():void {
    const horizontalDialogRef = this.dialog.open(CopyHorizontalComponent, {
      data: {template: this.template, size: this.size},
    });
    horizontalDialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.copyHorizontal(result);
      }
    });
  }

  showCopyVerticalModal():void {
    let verticalDialogRef = this.dialog.open(CopyVerticalComponent, {
      data: this.size,
    });
    verticalDialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.copyVertical(result);
      }
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/hq/cards/copy-configuration/copy-to/copy-to.component.ts